import type { IndicatorStatus } from '@openx/components-core/lib/StatusIndicator/StatusIndicator';
import { BidderCreativeStatus } from '@openx/types/gqlTypes';

export const creativeStatusMap: Record<BidderCreativeStatus, IndicatorStatus> = {
  [BidderCreativeStatus.Active]: 'active',
  [BidderCreativeStatus.Paused]: 'paused',
};
